<div class="page-layout simple fullwidth" [ngClass]="{'expanded-steps': this.dynamicFormService.isReadOnly==true}">
  <div [ngClass]="dynamicFormService.revisionMode ?
                      'horizontal-shared content p-24 bounce-in-2 horizontal-header-revision-mode' :
                      'horizontal-shared content p-24 bounce-in-2 horizontal-header-submit-mode'"
    when-visible="animateElementIn" when-not-visible="animateElementOut">
    <div class="container-fluid " style="height: 100vh;">
      <div class="bg-white shadow-sm p-5 m-3" >
        <form [formGroup]="radiationForm" (ngSubmit)="onSubmit()" class="radiation-form">
          <div class="row">
            <div class="col-12 mt-4 text-right">
              <button mat-raised-button
                      color="primary"
                      type="button"
                      [disabled]="!canEdit && !isViewMode"
                      (click)="closeForm()">
                <span *ngIf="!showMachineForm">Añadir máquina</span>
                <span *ngIf="showMachineForm">{{isViewMode ? 'Cerrar' : 'Cancelar'}}</span>
              </button>
            </div>
          </div>

          <div class="machine-entry mt-3" *ngIf="showMachineForm">
            <div class="row">
              <div class="col-12">
                <h4 class="text-start">{{isViewMode ? 'Ver' : (isEditMode ? 'Editar' : 'Información del')}} dueño o poseedor</h4>
              </div>
              <div class="col-md-12">
                <mat-form-field class="w-100">
                  <mat-label>Nombre del dueño o Poseedor</mat-label>
                  <input matInput formControlName="ownerName" required>
                  <mat-error *ngIf="radiationForm.get('ownerName')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-100">
                  <mat-label>Dirección</mat-label>
                  <input matInput formControlName="ownerAddress" required>
                  <mat-error *ngIf="radiationForm.get('ownerAddress')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="w-100">
                  <mat-label>Teléfono</mat-label>
                  <input matInput
                         formControlName="ownerPhone"
                         mask="(000)-0000000"
                         type="text"
                         required>
                  <mat-error *ngIf="radiationForm.get('ownerPhone')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-12">
                <h4 class="text-start">Maquinas de radiación</h4>
              </div>
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>Tipo</mat-label>
                  <mat-select formControlName="machineTypeId" required (selectionChange)="onChangeType($event)">
                    <mat-option *ngFor="let type of machineTypes" [value]="type.Id">
                      {{type.Name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="radiationForm.get('machineTypeId')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="w-100" *ngIf="otherType">
                  <mat-label>Especifique el tipo</mat-label>
                  <input matInput formControlName="machineTypeOther">
                  <mat-error *ngIf="radiationForm.get('machineTypeOther')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>Propósito</mat-label>
                  <mat-select formControlName="machinePurposeId" required (selectionChange)="onChangeMachinePurpose($event)">
                    <mat-option *ngFor="let purpose of purposeTypes" [value]="purpose.Id">
                      {{purpose.Name}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="radiationForm.get('machinePurposeId')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>
                <mat-form-field class="w-100" *ngIf="otherPurpose">
                  <mat-label>Especifique el propósito</mat-label>
                  <input matInput formControlName="machinePurposeOther">
                  <mat-error *ngIf="radiationForm.get('machinePurposeOther')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                <h4 class="text-start">Operación Máxima</h4>
              </div>
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>KVP</mat-label>
                  <input matInput formControlName="kvp" type="number">
                  <mat-error *ngIf="radiationForm.get('kvp')?.errors?.min">
                    El valor debe ser mayor a 0
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>mA</mat-label>
                  <input matInput formControlName="mA" type="number">
                  <mat-error *ngIf="radiationForm.get('mA')?.errors?.min">
                    El valor debe ser mayor a 0
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>Fija</mat-label>
                  <mat-select formControlName="fixed" required>
                    <mat-option value="Si">Sí</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                  <mat-error *ngIf="radiationForm.get('fixed')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-md-6">
                <mat-form-field class="w-100">
                  <mat-label>Móvil</mat-label>
                  <mat-select formControlName="mobile" required>
                    <mat-option value="Si">Sí</mat-option>
                    <mat-option value="No">No</mat-option>
                  </mat-select>
                  <mat-error *ngIf="radiationForm.get('mobile')?.errors?.required">
                    Este campo es requerido
                  </mat-error>
                </mat-form-field>
              </div>
            </div>

            <mat-form-field class="w-100">
              <mat-label>Manufacturero y Número de Modelo</mat-label>
              <input matInput formControlName="manufacturerAndModel" required>
              <mat-error *ngIf="radiationForm.get('manufacturerAndModel')?.errors?.required">
                Este campo es requerido
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-100">
              <mat-label>Nro. de serie</mat-label>
              <input matInput formControlName="serialNumber" required>
              <mat-error *ngIf="radiationForm.get('serialNumber')?.errors?.required">
                Este campo es requerido
              </mat-error>
            </mat-form-field>

            <mat-form-field class="w-100">
              <mat-label>Ubicación de la máquina dentro de la facilidad</mat-label>
              <input matInput formControlName="machineLocation">
            </mat-form-field>

            <div class="text-right mt-4" *ngIf="!isViewMode">
              <button mat-raised-button
                      color="primary"
                      type="submit"
                      [disabled]="!radiationForm.valid || isLoading || !canEdit">
                <mat-spinner diameter="20" *ngIf="isLoading" class="d-inline-block align-middle me-2" color="accent"></mat-spinner>
                {{isLoading ? 'Guardando...' : (isEditMode ? 'Actualizar máquina' : 'Guardar máquina')}}
              </button>
            </div>
          </div>


          <div class="mt-4">
            <h4 class="text-start">Máquinas registradas</h4>
            <div *ngIf="!canEdit" class="alert alert-warning d-flex align-items-center mb-3">
              <mat-icon class="me-2">info</mat-icon>
              <span>Este formulario está en modo de solo lectura. Solo se puede editar cuando la transacción esté en estado "Borrador" o marcada para verificación.</span>
            </div>
            <div *ngIf="!dataSource?.filteredData.length" class="alert alert-info d-flex align-items-center">
              <mat-icon class="me-2">info</mat-icon>
              Aún no hay máquinas añadidas, para añadir una de click en el botón.
            </div>
            <ng-container *ngIf="dataSource?.filteredData.length!=0">
              <table mat-table [dataSource]="dataSource">
                <ng-container matColumnDef="Tipo">
                  <th mat-header-cell *matHeaderCellDef>Tipo</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.MachineTypeId === 'c530f4b6-ad8e-4585-9394-dbaaca98656a'; else defaultType">
                      {{element.MachineTypeOther}}
                    </ng-container>
                    <ng-template #defaultType>
                      {{getMachineTypeName(element.MachineTypeId)}}
                    </ng-template>
                  </td>
                </ng-container>

                <ng-container matColumnDef="Proposito">
                  <th mat-header-cell *matHeaderCellDef>Propósito</th>
                  <td mat-cell *matCellDef="let element">
                    <ng-container *ngIf="element.MachinePurposeId === '84be5006-c3d1-4a82-9c6d-8ee1d64dd298'; else defaultPurpose">
                      {{element.MachinePurposeOther}}
                    </ng-container>
                    <ng-template #defaultPurpose>
                      {{getMachinePurposeName(element.MachinePurposeId)}}
                    </ng-template>
                  </td>
                </ng-container>

                <ng-container matColumnDef="KvP">
                  <th mat-header-cell *matHeaderCellDef>KvP</th>
                  <td mat-cell *matCellDef="let element">{{element.Kvp}}</td>
                </ng-container>

                <ng-container matColumnDef="mA">
                  <th mat-header-cell *matHeaderCellDef>mA</th>
                  <td mat-cell *matCellDef="let element">{{element.mA}}</td>
                </ng-container>

                <ng-container matColumnDef="Fija">
                  <th mat-header-cell *matHeaderCellDef>Fija</th>
                  <td mat-cell *matCellDef="let element">{{element.Fixed}}</td>
                </ng-container>

                <ng-container matColumnDef="Movil">
                  <th mat-header-cell *matHeaderCellDef>Móvil</th>
                  <td mat-cell *matCellDef="let element">{{element.Mobile}}</td>
                </ng-container>

                <ng-container matColumnDef="Manufacturero y Nro. Modelo">
                  <th mat-header-cell *matHeaderCellDef>Manufacturero y Nro. Modelo</th>
                  <td mat-cell *matCellDef="let element">{{element.ManufacturerAndModel}}</td>
                </ng-container>

                <ng-container matColumnDef="Nro. de serie">
                  <th mat-header-cell *matHeaderCellDef>Nro. de serie</th>
                  <td mat-cell *matCellDef="let element">{{element.SerialNumber}}</td>
                </ng-container>

                <ng-container matColumnDef="Acciones">
                  <th mat-header-cell *matHeaderCellDef class="text-center">Acciones</th>
                  <td mat-cell *matCellDef="let element" class="text-center">
                    <div class="d-flex flex-row justify-content-center align-items-center">
                      <button mat-button type="button" class="btn btn-light" matTooltip="Ver máquina" (click)="viewMachine(element)">
                        <mat-icon>visibility</mat-icon>
                      </button>
                      <ng-container *ngIf="canEdit">
                        <button mat-button type="button" class="btn btn-light" matTooltip="Editar solicitud" (click)="editMachine(element)">
                          <img src="assets/images/salud/transactions/edit_document.svg" alt="Editar">
                        </button>
                        <button mat-button type="button" class="btn btn-light" matTooltip="Remover solicitud" (click)="deleteMachine(element)">
                          <img src="assets/images/salud/transactions/delete_forever.svg" alt="Remover">
                        </button>
                      </ng-container>
                    </div>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
              </table>
            </ng-container>
          </div>
          <div class="col-12 mt-4 text-right">
            <button mat-raised-button
                    color="primary"
                    type="button"
                    [disabled]="(machineList.length===0) || isSaving ||
                    (transactionService.itemToEdit.CurrentStatusId !== -12) ||
                    (transactionRequirementService.requirementItem.IsFlagedForVerification !== null)"
                    (click)="save()">
              <mat-spinner diameter="20" *ngIf="isSaving" class="d-inline-block align-middle me-2" color="accent"></mat-spinner>
              <span>{{isSaving ? 'Finalizando...' : 'Finalizar'}}</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>

